export const applyExpressionismStyle = async (canvas, ctx, setMessage, language) => {
  // 표현주의: 감정적 왜곡과 강렬한 색채
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 극도로 강화된 색채
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    
    // 가장 강한 색상 채널을 더욱 강화
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    
    if (max - min > 50) { // 색상 대비가 있는 경우
      if (r === max) {
        data[i] = Math.min(255, r * 1.5);
        data[i + 1] = Math.max(0, g * 0.7);
        data[i + 2] = Math.max(0, b * 0.7);
      } else if (g === max) {
        data[i] = Math.max(0, r * 0.7);
        data[i + 1] = Math.min(255, g * 1.5);
        data[i + 2] = Math.max(0, b * 0.7);
      } else {
        data[i] = Math.max(0, r * 0.7);
        data[i + 1] = Math.max(0, g * 0.7);
        data[i + 2] = Math.min(255, b * 1.5);
      }
    }
    
    // 전체적인 콘트라스트 극대화
    const brightness = (data[i] + data[i + 1] + data[i + 2]) / 3;
    if (brightness < 128) {
      data[i] = Math.max(0, data[i] * 0.8);
      data[i + 1] = Math.max(0, data[i + 1] * 0.8);
      data[i + 2] = Math.max(0, data[i + 2] * 0.8);
    } else {
      data[i] = Math.min(255, data[i] * 1.2);
      data[i + 1] = Math.min(255, data[i + 1] * 1.2);
      data[i + 2] = Math.min(255, data[i + 2] * 1.2);
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 형태 왜곡 효과
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const distortData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const distortPixels = distortData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 파동 왜곡 효과
  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      // 파동 함수를 이용한 왜곡
      const waveX = Math.sin(y * 0.02) * 5;
      const waveY = Math.cos(x * 0.02) * 5;
      
      const sourceX = Math.max(0, Math.min(canvas.width - 1, x + waveX));
      const sourceY = Math.max(0, Math.min(canvas.height - 1, y + waveY));
      const sourcePos = (Math.floor(sourceY) * canvas.width + Math.floor(sourceX)) * 4;
      
      distortPixels[pos] = tempData[sourcePos];
      distortPixels[pos + 1] = tempData[sourcePos + 1];
      distortPixels[pos + 2] = tempData[sourcePos + 2];
      distortPixels[pos + 3] = tempData[sourcePos + 3];
    }
  }
  
  ctx.putImageData(distortData, 0, 0);
  
  // 3. 거친 붓터치 효과
  const roughData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const roughPixels = roughData.data;
  
  for (let i = 0; i < roughPixels.length; i += 4) {
    // 강한 질감 추가
    if (Math.random() > 0.85) {
      const roughness = (Math.random() - 0.5) * 60;
      for (let c = 0; c < 3; c++) {
        roughPixels[i + c] = Math.min(255, Math.max(0, roughPixels[i + c] + roughness));
      }
    }
  }
  
  ctx.putImageData(roughData, 0, 0);
};